const validate = {
  methods: {
    validateEmail(email) {
      const regex = /^\w+([+-.']?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;
      return regex.test(email);
    }
  }
};

export default validate



// WEBPACK FOOTER //
// ./src/mixins/validate.js